import React, { useMemo } from 'react';
import { FileText, Image } from 'lucide-react';
import { KeyType } from '../../types/keyRegister';
import { typeAttachments } from '../../Helpers/keyRegisterUtils';
import { formatFileSize } from '../../Helpers/FileUtils';
import { useStorageUrls } from './useStorageUrls';

interface KeyTypeFilesProps {
    type: KeyType;
    getUrl: (storagePath: string) => Promise<string>;
}

/** A key type's files as links that open in a new tab, newest first. Added and removed in the type modal. */
const KeyTypeFiles: React.FC<KeyTypeFilesProps> = ({ type, getUrl }) => {
    const attachments = useMemo(() => typeAttachments(type), [type]);
    const urls = useStorageUrls(attachments.map(a => a.storagePath), getUrl);
    if (attachments.length === 0) return null;

    return (
        <ul className="key-section-files" aria-label="Filer">
            {attachments.map(attachment => {
                const Icon = attachment.mimeType.startsWith('image/') ? Image : FileText;
                const url = urls[attachment.storagePath];
                return (
                    <li key={attachment.key}>
                        <Icon size={14} aria-hidden="true" />
                        {url
                            ? <a href={url} target="_blank" rel="noopener noreferrer">{attachment.fileName}</a>
                            : <span className="text-muted">{attachment.fileName}</span>}
                        <span className="key-section-file-size">{formatFileSize(attachment.fileSize)}</span>
                    </li>
                );
            })}
        </ul>
    );
};

export default KeyTypeFiles;
